
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup"
import * as S from "../style"
import { IObterListaRiscoMotivoResponse, IAlterarRiscoMotivo } from '../../../services/models/Configuracoes/RiscoMotivo/index';
import { useEffect, useState } from "react";
import { adicionarRiscoMotivo, alterarRiscoMotivo, excluirRiscoMotivo, obterListaRiscoMotivo } from "../../../services/api/Configuracoes/RiscoMotivo";
import Template from "../../../components/Template";
import { PencilSimple, Trash } from "phosphor-react";
import ActionButton from "../../../components/ActionButton";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import ItemsList, { HeaderList, ListItem } from "../../../components/ItemsList";
import ModalAction from "../../../components/ModalAction";
import PageTitle from "../../../components/PageTitle";
import TabSwitcher from "../../../components/TabSwitcher";
import { usePermissionsStore } from "../../../stores/PermissionsStore";

const AddRiskReasonSchema = yup.object({
    descricao: yup.string().required("O nome é obrigatório.")
})

interface item extends IObterListaRiscoMotivoResponse {}

const RiskReason = () => {
    const [view, setView] = useState<number>(0)
    const [RiskReasonList, setRiskReasonList] = useState<any>(null)

    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
    const [showEditModal, setShowEditModal] = useState<boolean>(false)
    const [itemToDelete, setItemToDelete] = useState<item | null>(null)
    const [itemToEdit, setItemToEdit] = useState<item | null>(null)

    useEffect(() => {
        view === 0 && ObterListaRiscoMotivo()
    }, [view])

    const {
        handleSubmit,
        control,
        reset,
        formState: {
            errors,
            isValid
        }
    } = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        resolver: yupResolver(AddRiskReasonSchema)
    })

    const ObterListaRiscoMotivo = async () => {
        let res = await obterListaRiscoMotivo()
        setRiskReasonList(res)
    }

    const AdicionarRiscoMotivo = async (data: any) => {
        let body = {
            ...data
        }

        await adicionarRiscoMotivo(body).then(() => {
            reset({
                descricao: null
            })
        })
    }

    const ExcluirRiscoMotivo = async (idRiscoMotivoInterrupcaoProjecao: number) => {
        await excluirRiscoMotivo({ idRiscoMotivoInterrupcaoProjecao })
        ObterListaRiscoMotivo()
    }

    const EditarRiscoMotivo = async (newRiscoMotivo: IAlterarRiscoMotivo) => {
        await alterarRiscoMotivo(newRiscoMotivo)
        ObterListaRiscoMotivo()
    }

    const handleShowDeleteModal = (item: item) => {
        setItemToDelete(item)
        setShowDeleteModal(true)
    }

    const handleShowEditModal = (item: item) => {
        setItemToEdit(item)
        setShowEditModal(true)
    }

    const findPermission = usePermissionsStore((state) => state.findPermission);

    const permissions = findPermission(8);

    // PARA TESTE
    // const permissions = {
    //     permiteInserir: false,
    //     permiteAlterar: false,
    //     permiteExcluir: false,
    // }

    const {
        permiteInserir,
        permiteAlterar,
        permiteExcluir
    } = permissions;

    const menuItems = permiteInserir ?
        [
            "Dados",
            "Adicionar"
        ] : [
            "Dados"
        ]

    const headerList = permiteAlterar || permiteExcluir ?
        [
            "Descrição",
            "Status",
            "Ações"
        ] : [
            "Descrição",
            "Status"
        ]
    
    return (
        <Template>
            <PageTitle>
                Motivos de Interrupção
            </PageTitle>
            <TabSwitcher
                list={menuItems}
                view={view}
                setView={setView}
            />
            <S.Content>
                <S.ControlView active={view === 0}>
                    {
                        RiskReasonList ? (
                            <ItemsList>
                                <HeaderList items={headerList} />
                                {
                                    RiskReasonList.map((item: item, index: any) => {
                                        return (
                                            <ListItem key={index}>
                                                <div>{item.descricao}</div>
                                                <div>{item.isAtivo ? "Ativo" : "Inativo"}</div>
                                                {
                                                    (
                                                        permiteAlterar ||
                                                        permiteExcluir
                                                    ) && (
                                                        <div>
                                                            {
                                                                permiteAlterar && (
                                                                    <ActionButton act="edit" onClick={() => handleShowEditModal(item)}>
                                                                        <PencilSimple />
                                                                    </ActionButton>
                                                                )
                                                            }
                                                            {
                                                                permiteExcluir && (
                                                                    <ActionButton act="delete" onClick={() => handleShowDeleteModal(item)}>
                                                                        <Trash />
                                                                    </ActionButton>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </ListItem>
                                        )
                                    })
                                }
                            </ItemsList>
                        ) : (
                            <p>Carregando ...</p>
                        )
                    }
                </S.ControlView>
                <S.ControlView active={view === 1} id="addRisk" onSubmit={handleSubmit((data) => AdicionarRiscoMotivo(data))}>
                    <S.GridItem cols={2}>
                        <Input
                            id="descricao"
                            name="descricao"
                            label="Descrição"
                            control={control}
                            error={errors.descricao?.message}
                        />
                    </S.GridItem>
                    {
                        isValid && (
                            <S.GridItem cols={6}>
                                <Button type="submit" form="addRisk">Adicionar</Button>
                            </S.GridItem>
                        )
                    }
                </S.ControlView>
            </S.Content>
            {
                showDeleteModal && itemToDelete && (
                    <ModalAction
                        type="delete"
                        onConfirm={() => ExcluirRiscoMotivo(itemToDelete.id)}
                        onClose={() => setShowDeleteModal(false)}
                        title="Excluir Motivo de Interrupção"
                        item={itemToDelete}
                    />
                )
            }
            {
                showEditModal && itemToEdit && (
                    <ModalAction
                        type="edit"
                        onConfirm={(e) => EditarRiscoMotivo(e)}
                        onClose={() => setShowEditModal(false)}
                        title="Editar Motivo de Interrupção"
                        item={itemToEdit}
                    />
                )
            }
        </Template>
    )

}

export default RiskReason